/***        发票申请       ***/
<template>
  <div class="invoice">
    <div class="invoice-type">
      <div class="type-row">
        <span class="row-col" :ac="allState" @click="typeColAllAcFn" v-if="servesTypeNav.length>1">全部</span>
        <span class="row-col" :ac="ids.includes(item.business)" @click="typeColAcFn(item.business)"
              v-for="(item,index) in (servesTypeNav || [])" :key="index">{{item.name}}</span>
      </div>
      <div class="type-but" :ac="Boolean(ids)" @click="invoicePayFn">去开票</div>
    </div>
    <div class="operating">
      <div class="opt-row" @click="routerAcFn('/invoiceRecord')">
        开票记录
        <i class="iconfont icon-jiantou"></i>
      </div>
      <div class="opt-row">
        开票规则
        <i class="iconfont icon-jiantou"></i>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkNavTabs from '../../module/navTbas/src/navTabs.vue'

  export default {
    components: {XkNavTabs},
    name: 'invoice',
    computed: {
      ...mapGetters({
        servesTypeNav: 'servesTypeNav'
      })
    },
    data () {
      return {
        ids: '', // 选中的id
        allState: false // 全部选择的按钮
      }
    },
    watch: {
      ids (ids) {
        let state = true
        let servesTypeNav = this.servesTypeNav
        servesTypeNav.forEach((row) => {
          if (!ids.includes(row.business)) {
            state = false
          }
        })
        this.allState = state
      }
    },
    methods: {
      routerAcFn (path) {
        this.$router.push(path)
      },
      typeColAcFn (id) { // 业务选择
        let ids = this.ids
        if (ids) {
          if (ids.includes(id)) {
            this.ids = ids.replace(id + ',', '')
          }
        } else {
          this.ids += id + ','
        }
      },
      typeColAllAcFn () { // 全部业务
        let servesTypeNav = this.servesTypeNav
        this.ids = ''
        if (!this.allState) {
          this.ids = ''
          servesTypeNav.forEach((row) => {
            this.ids += row.business + ','
          })
        }
      },
      invoicePayFn () { // 去开票
        if (this.ids) {
          this.$router.push({path: '/invoiceOrderRecord', query: {business: this.ids}})
        }
      }
    },
    mounted: function () {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .invoice {
    width: 100%;
    height: 100%;
    .invoice-type {
      margin: 1rem;
      padding: 1rem;
      background: #fff;
      border-radius: .4rem;
      .type-row {
        margin-bottom: 1.6rem;
      }
      .row-col {
        line-height: 2.2rem;
        padding: 0 1.2rem;
        color: #999;
        border-radius: 1.1rem;
        border: 1px solid rgba(0, 0, 0, .05);
        transition: 0.3s all;
      }
      .row-col + .row-col {
        margin-left: .8rem;
      }
      .row-col[ac=true] {
        color: #f06553;
        border-color: #f06553;
      }
    }
    .type-but {
      line-height: 3.4rem;
      background: rgba(0, 0, 0, .1);
      text-align: center;
      border-radius: .4rem;
      color: #999;
      font-size: 1.1rem;
      transition: 0.3s all;
    }
    .type-but[ac=true] {
      background: #f06553;
      color: #fff;
    }
    .operating {
      margin: 1rem;
      border-radius: .4rem;
      padding: 0 1rem;
      background: #fff;
    }
    .opt-row {
      line-height: 3.8rem;
      font-size: 1.2rem;
      color: #333;
    }
    .iconfont {
      float: right;
      font-size: 1rem;
      color: #999;
    }
    .opt-row + .opt-row {
      border-top: 1px solid #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// invoice.vue?dd9e1c7e